import { createFocusContainer, removeFocusContainer, addTimer } from "../helpers-focus.js";
import { shuffle } from "../utils.js";

/*
 * Creates a focus container with squares of different point values and button in the middle
 * Pressing the button captures the points
 * */
function clickFortune({ gameState, board }) {
  return new Promise((resolve) => {
    const focusContainer = createFocusContainer({ board });
    let clicked = false;
    let currentSelectedSquare = null;
    let intervalId = null;
    let timerId = null
    const TIMER_LENGTH = 8;

    const { timerDiv, startTimer, stopTimer, } = addTimer(TIMER_LENGTH, () => {
      // If time runs out apply the most selected square by default
      if (!clicked && currentSelectedSquare) {
        gameState.updateScore(parseInt(currentSelectedSquare.dataset.value));
        clearInterval(intervalId);
        // stopTimer(timerId,() => {removeFocusContainer(focusContainer)});
        stopTimer(timerId)
        removeFocusContainer(focusContainer, { board });
        resolve();
      }
    });
    focusContainer.appendChild(timerDiv);
    //
    // [50, 100, 200] 7 / 2, [500, 1000]  3 / 3, game over * 3 
    const prizes = [
      50, 50, 50, 50,
      100, 100, 100,
      200, 200, 200,
      500, 500,
      1000, 1000,
      -50, -500, -1000,
      -1_000_000, -1_000_000,
    ]
    shuffle(prizes);



    const NUM_SQUARES = 18;
    const pressBoard = document.createElement("div");
    pressBoard.classList.add("fortune__board");
    focusContainer.appendChild(pressBoard);

    for (let i = 0; i < NUM_SQUARES; i++) {
      const square = document.createElement("div");
      square.classList.add("fortune__square")
      if (i < 6) {
        square.style.gridRow = 1
        square.style.gridColumn = i + 1;
        square.classList.add("first-row");
      }
      else if (i > 11) {
        square.style.gridRow = 5
        square.style.gridColumn = (i + 1) % 6;
        square.classList.add("last-row");
      }
      else {
        square.style.gridRow = Math.floor((i - 6) / 2) + 2;
        square.style.gridColumn = i % 2 === 0 ? 1 : 6;
      }
      //  0  1  2  3  4  5 
      //  6              7 
      //  8              9
      // 10              11
      // 12 13 14 15 16  17 

      pressBoard.appendChild(square);
    }
    const squares = Array.from(pressBoard.children);
    const pressButton = document.createElement("button");
    pressButton.innerText = "Click Your Fortune!";
    pressButton.classList.add("fortune__button");
    pressButton.addEventListener("click", () => {
      gameState.updateScore(parseInt(currentSelectedSquare.dataset.value));
      clicked = true;
      clearInterval(intervalId);
      removeFocusContainer(focusContainer, { board });
      resolve();
    });

    pressBoard.appendChild(pressButton);

    const formatter = new Intl.NumberFormat();

    squares.forEach((square, i) => {
      square.innerText = prizes[i] !== -1_000_000 ? formatter.format(prizes[i]) : '-1M';
      square.dataset.value = prizes[i];
    })

    intervalId = setInterval(
      () => {
        if (currentSelectedSquare) {
          currentSelectedSquare.classList.remove("fortune__square--focus");
        }
        currentSelectedSquare = squares[Math.floor(Math.random() * squares.length)];
        // console.log(Math.floor(Math.random() * squares.length));
        currentSelectedSquare.classList.add("fortune__square--focus");
      }
      , 230)

    startTimer();

  });
}

export default clickFortune;
